export default __webpack_public_path__ + "static/media/vintage.70fb60c7.png";